module.exports = __webpack_public_path__ + "static/media/sensorium.0175d958.jpeg";